import { FunctionComponent } from 'react';
import { InputTypes } from '../../configuration/fieldTypes';
import { TransactionFieldProps } from './TransactionField';
import styles from './CheckboxField.module.scss';

export const CheckboxField: FunctionComponent<TransactionFieldProps> = ({
	field,
	className,
	disabled,
	defaultValue,
	labelRef,
	showValidation,
	changeHandler
}) => {
	return (
		<>
			<div className={styles.container}>
				{showValidation && (
					<div className={styles.validation}>
						<b>
							<i>{field.ValidationMessage}</i>
						</b>
					</div>
				)}
				{/* eslint-disable-next-line enforce-ids-in-jsx/missing-ids */}
				<input
					className={`${styles.checkbox} ${className || ''} ${showValidation ? styles.hasError : ''}`}
					type={InputTypes.Checkbox}
					disabled={disabled}
					id={field.Key}
					name={field.Key}
					defaultChecked={!!defaultValue}
					onChange={(event) => {
						const checked = event.target.checked;
						field.SetValue(checked ? 'checked' : '');
						changeHandler?.(event);
					}}
					data-testid="CheckboxFieldInput"
				/>
				<label htmlFor={field.Key} className={styles.checkboxLabel} ref={labelRef}>
					{field.Label}
				</label>
			</div>
		</>
	);
};
